import {
  basicCharacterPatternMessage,
  basicCharacterRegexWithLineBreak,
} from "@validations/common";
import { validationOfRequired } from "@validations/required";
import classNames from "classnames";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { FormError } from "@components/FormRow";
import { Text } from "@components/Text";
import styles from "./index.module.css";
import type { RequestReservationInputForm } from "@pages/shops/[uuid]/request_reservation/_useRequestReservationForm";
import type { FC } from "react";

type Props = {
  hint?: string;
  isEvent?: boolean;
};

export const ReservationFormUserMessage: FC<Props> = ({ hint, isEvent }) => {
  const {
    register,
    trigger,
    formState: { errors },
  } = useFormContext<RequestReservationInputForm>();
  const errorMessage = errors.userMessage?.message;

  useEffect(() => {
    if (errors.userMessage) {
      trigger("userMessage");
    }
  }, [isEvent]);

  return (
    <dl>
      <dt className={styles.title}>
        {!isEvent && <p className={styles.status}>任意</p>}
        <Text size={14} bold>
          {isEvent ? "確認事項" : "お店へのメッセージ"}
        </Text>
      </dt>
      <dd>
        {hint && <pre className={styles.hint}>{hint}</pre>}
        <textarea
          {...register("userMessage", {
            required: isEvent && validationOfRequired,
            maxLength: { value: 200, message: "200文字以内で入力してください" },
            pattern: {
              value: basicCharacterRegexWithLineBreak,
              message: basicCharacterPatternMessage,
            },
          })}
          className={classNames(styles.textarea, errorMessage && styles.error)}
          placeholder={isEvent ? "入力してください" : "メッセージを入力"}
        />
        {errorMessage && <FormError>{errorMessage}</FormError>}
      </dd>
    </dl>
  );
};
